export { default } from './ClassNameGenerator';


//////////////////
// WEBPACK FOOTER
// ../@mui/utils/esm/ClassNameGenerator/index.js
// module id = 370
// module chunks = 22